import React from "react";

// import WinnerTabs from "../components/WinnerTabs";

import { __ } from "services/Translator";

import GameSlider from "elements/gameElements/GameSlider";
import Winners from "components/Winners";


const providerHeaders = [
  // Big Wins
  <div
    className="providers-section-header d-flex align-items-center"
    key="big-wins"
  >
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="m-icon m-icon-loadable"
      name={__("TargetBigWins")}
      width="32"
      height="32"
      style={{ marginRight: 8, color: "#A2A5AF" }}
    >
      <path
        d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m5.758 8.858-2.025 2a.74.74 0 0 0-.216.659l.466 2.816a.758.758 0 0 1-1.1.792l-2.5-1.308a.83.83 0 0 0-.7 0l-2.5 1.308a.758.758 0 0 1-1.1-.792l.467-2.816a.74.74 0 0 0-.217-.659l-2.033-2a.767.767 0 0 1 .425-1.3l2.817-.425a.78.78 0 0 0 .566-.408l1.217-2.558a.758.758 0 0 1 1.358 0l1.275 2.55a.76.76 0 0 0 .567.408l2.817.425a.767.767 0 0 1 .416 1.325z"
        fill="currentColor"
      ></path>
    </svg>
    <span style={{ fontSize: 28, fontWeight: 700, lineHeight: "40px" }}>
      Big Wins
    </span>
  </div>,
  // Top Game
  <div
    className="providers-section-header d-flex align-items-center"
    key="top-games"
  >
    <img
      src="https://cdn.ninestatic.com/images/file/uploads/366860199025535463.svg"
      alt={__("Top Games")}
      width={32}
      height={32}
      style={{ marginRight: 8 }}
      loading="lazy"
    />
    <span style={{ fontSize: 28, fontWeight: 700, lineHeight: "40px" }}>
      Top Games
    </span>
  </div>,
  // Exclusive
  <div
    className="providers-section-header d-flex align-items-center"
    key="exclusive"
  >
    <span style={{ fontSize: 28, fontWeight: 700, lineHeight: "40px" }}>
      Exclusive
    </span>
  </div>,
  // Live Games
  <div
    className="providers-section-header d-flex align-items-center"
    key="live-games"
  >
    <img
      src="https://cdn.ninestatic.com/images/file/uploads/5350198553587283.svg"
      alt={__("Live Games")}
      width={32}
      height={32}
      style={{ marginRight: 8 }}
      loading="lazy"
    />
    <span style={{ fontSize: 28, fontWeight: 700, lineHeight: "40px" }}>
      Live Games
    </span>
  </div>,
];

const Lobby = (props) => {
  return (
    <div className="lobby-content-container container-xxl">
      {/* <LobbyBanners /> */}
      {/* Big Wins and Top Games sections below LobbyBanners */}
      {/* <LobbySlider /> */}
      <GameSlider
        categoryLabel={__("Slots")}
        menuBar={false}
        category="video_slots"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel={__("Video Table Games")}
        menuBar={false}
        category="table_games"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      
      <GameSlider
        categoryLabel={__("Jackpot")}
        menuBar={false}
        category="jackpot"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      {/* <PwaBanner /> */}
      
      <GameSlider
        categoryLabel={__("Skills")}
        menuBar={false} 
        category="skills"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel={__("Crush Games")}
        menuBar={false}
        category="crash"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      {/* <GameSlider
        categoryLabel={__("Hot Games")}
        menuBar={false}
        category="table_games"
        perPage="20"
        title={true}
        slideToShow={7}
        {...props}
      /> */}
      {/* <WinnerTabs /> */}
      
      <GameSlider
        categoryLabel="New"
        menuBar={false}
        category="new"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel={__("All Live Games")}
        menuBar={false}
        category="live_casino"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel={__("Blackjack")}
        menuBar={false}
        category="blackjack"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel={__("Roulette")}
        menuBar={false}
        category="roulette"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel={__("Baccarat")}
        menuBar={false}
        category="baccarat"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel="Game Shows"
        menuBar={false}
        category="game_shows"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <GameSlider
        categoryLabel="Others"
        menuBar={false}
        category="others"
        perPage="20"
        title={true}
        slideToShow={8}
        {...props}
      />
      <Winners {...props} />

      {/* <ProvidersSection header={providerHeaders[1]} /> */}
      {/* <ProvidersSection header={providerHeaders[0]} />

      <ProvidersSection header={providerHeaders[1]} />
      <GameSlotOne />
      <GameSlotTwo /> */}
      {/* Remaining Providers sections in their previous positions */}
      {/* <ProvidersSection header={providerHeaders[2]} />
      <GameSlotOne />
      <ProvidersSection header={providerHeaders[3]} />
      <GameSlotOne />
      <br />
      <PwaBanner /> */}
      {/* Original Providers section with title 'Providers' above FeedbackSection */}
      {/* <ProvidersSection
        header={
          <h2 className="m-text Header-Bold-L providers-section-header flex-grow-1 m-0 p-0">
            Providers
          </h2>
        }
      /> */}
      {/* <FeedbackSection />
      <CashbackBreadcrumb /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default Lobby;
